import EnclosureCommon from "./enclosureCommon";

export default class EnclosureTop extends EnclosureCommon {

  constructor(isChild) {
    super(isChild);
    this.partId = 'enclosure_top';
    this.dbName = 'EnclosureTop';
    this.partName = 'Enclosure Top';
    this.translateId = "visualizer.bathroom.shower.enclosure_top";
    this.canBeDisabled = false;
    this.isStoneFeature = true;
  }

}
